// extracted by mini-css-extract-plugin
export default {"bgDark":"style_bgDark__JzbLi","dialogOpne":"style_dialogOpne__9ooqP","dialogClose":"style_dialogClose__q+dnI"};